import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export const ssblnk = (text) => {
    const res = [];
    const mm = text.matchAll(/(\d{5})/g);
    let offset = 0;
    mm.forEach((m) => {
        const tokenPos = text.indexOf(m[1], offset);
        if (tokenPos === -1) {
            res.push(text.substring(offset ? offset + 5 : 0));
        }
        else if (offset < text.length) {
            res.push(text.substring(offset, tokenPos));
            res.push(_jsx("a", { className: "ssb-table-link ext-link", href: `https://www.ssb.no/statbank/table/${m[1]}`, title: "G\u00E5 til statistikkbanken (SSB)", children: m[1] }, `ssb-${m[1]}-${tokenPos}`));
            offset = tokenPos + 5;
        }
    });
    if (offset < text.length) {
        res.push(text.substring(offset));
    }
    return _jsx(_Fragment, { children: res });
};
